import { render, staticRenderFns } from "./InstallmentRecord.vue?vue&type=template&id=00bcf4b6&scoped=true&"
import script from "./InstallmentRecord.vue?vue&type=script&lang=js&"
export * from "./InstallmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InstallmentRecord.vue?vue&type=style&index=1&id=00bcf4b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcf4b6",
  null
  
)

export default component.exports